// src/lib/analytics/anon-id.ts
//
// The stable per-browser id the client tracker attributes logged-out events
// to. Shared by the root tracker (ClientAnalytics) and the learning path's own
// event sender, so an anonymous visitor's lesson views and their later
// pageviews stitch to one subject. Browser-only; returns null wherever
// localStorage is unavailable.

export const ANON_ID_KEY = 'ut_anon_id'

export function getAnonId(): string | null {
  try {
    let id = localStorage.getItem(ANON_ID_KEY)
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `a_${Date.now()}_${Math.random().toString(36).slice(2)}`
      localStorage.setItem(ANON_ID_KEY, id)
    }
    return id
  } catch {
    return null
  }
}
